import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import BackButton from 'components/backButton'
import { CreateBundleProductForm } from 'components/bundleProduct'
import {
  createProductSchema,
  CreateProductFormFields,
} from 'utils/schema/bundleProductSchema'
import { createProduct } from 'utils/api/bundleProductApi'
import { handleError } from 'utils/helpers/handleError'
import { PAGE_BUNDLE_PRODUCT } from 'utils/constants'
import { PRODUCT_TYPE } from 'types/bundleProduct'

const CreateBundleProduct = () => {
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<CreateProductFormFields>({
    resolver: yupResolver(createProductSchema),
    defaultValues: {
      productType: PRODUCT_TYPE.BUNDLE,
      description: '',
      dept: '',
      section: '',
      family: '',
      subFamily: '',
      uom: '',
      vatClass: '',
      quantityStep: 1,
      bundleItems: [],
    },
  })

  const handleCreateProduct = async (data: CreateProductFormFields) => {
    const toastId = toast.loading('Creating Bundle Product...', {
      duration: Infinity,
    })

    try {
      await createProduct(data)
      toast.success('Bundle Product created successfully', {
        id: toastId,
        duration: 3000,
      })
      navigate(PAGE_BUNDLE_PRODUCT.path)
    } catch (error) {
      handleError(
        error,
        toastId,
        {
          default: 'Failed to create Bundle Product. Please try again.',
        },
        5000,
      )
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Add Bundle Product</title>
      </Helmet>

      <BackButton />

      <form onSubmit={handleSubmit(handleCreateProduct)}>
        <CreateBundleProductForm
          register={register}
          control={control}
          setValue={setValue}
          errors={errors}
        />
      </form>
    </>
  )
}

export default CreateBundleProduct
